import { createContext } from "react";
import { jsx } from "react/jsx-runtime";
const ClientOnlyContext = createContext(!1),
  ClientOnly = ({
    children,
    value = !0
  }) => /* @__PURE__ */jsx(ClientOnlyContext.Provider, {
    value,
    children
  });
export { ClientOnly, ClientOnlyContext };
//# sourceMappingURL=ClientOnly.mjs.map
